import { Button } from "@/components/ui/baseUi/button"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/baseUi/dialog"
import { WarningTriangleIcon } from "@images/svgIcons/warningIcon"
import { word } from "@modules/core/utils/i18n"
import { useImperativeHandle, useState } from "react"
import { Text } from "@/components/ui/baseUi/text"

type ProgramBundlePauseOnOffModalProps = {
  onConfirmUnfollow: () => void
  ref: React.Ref<ProgramBundlePauseOnOffModalRef>
}

export type ProgramBundlePauseOnOffModalRef = {
  open: () => void
}

export function ProgramBundlePauseOnOffModal({ onConfirmUnfollow, ref }: ProgramBundlePauseOnOffModalProps) {
  const [dialogIsVisible, setDialogIsVisible] = useState(false)

  const closeDialog = () => {
    setDialogIsVisible(false)
  }

  const onClickConfirm = () => {
    onConfirmUnfollow()
    closeDialog()
  }

  useImperativeHandle(ref, () => ({
    open: () => {
      setDialogIsVisible(true)
    },
  }))

  return (
    <Dialog open={dialogIsVisible} onOpenChange={setDialogIsVisible}>
      <DialogContent className="h-83 w-128">
        <DialogHeader className="flex flex-col gap-4">
          <DialogTitle>{word("programBundle.follow.remove.impossible.title")}</DialogTitle>
          <DialogDescription className="mb-5 flex flex-row">
            <WarningTriangleIcon color="currentColor" width={50} height={50} className="text-textDefault-caption" />
            <Text fontStyle="TL">{word("programBundle.follow.remove.onoff.paused.title")}</Text>{" "}
          </DialogDescription>
        </DialogHeader>

        <Text fontStyle="BM" className="text-center">
          {word("programBundle.follow.remove.onoff.paused.explanation")}
        </Text>

        <DialogFooter>
          <DialogClose
            render={
              <Button variant="outline" className="flex-1" onClick={closeDialog}>
                {word("global.cancel")}
              </Button>
            }
          />
          <Button variant="primary" className="flex-1" onClick={onClickConfirm}>
            {word("programBundle.follow.remove.onoff.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
